import {
  FETCHING_EMAIL_TEMPLATES_REQUEST,
  FETCHING_EMAIL_TEMPLATES_SUCCEDDED,
  FETCHING_EMAIL_TEMPLATES_FAILED,
  INVALIDATE_EMAIL_TEMPLATES,
  SELECTION_EMAIL_TEMPLATE,
  INVALIDATE_SELECTION_EMAIL_TEMPLATE,
  CREATING_EMAIL_TEMPLATE_REQUEST,
  CREATING_EMAIL_TEMPLATE_SUCCEDDED,
  CREATING_EMAIL_TEMPLATE_FAILED,
  UPDATING_EMAIL_TEMPLATE_REQUEST,
  UPDATING_EMAIL_TEMPLATE_SUCCEDDED,
  UPDATING_EMAIL_TEMPLATE_FAILED,
  DELETING_EMAIL_TEMPLATE_REQUEST,
  DELETING_EMAIL_TEMPLATE_SUCCEDDED,
  DELETING_EMAIL_TEMPLATE_FAILED,
  FETCHING_EMAIL_TEMPLATE_REQUEST,
  FETCHING_EMAIL_TEMPLATE_SUCCEDDED,
  FETCHING_EMAIL_TEMPLATE_FAILED,
  FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST,
  FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED,
  FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED,
  INVALIDATE_DEFAULT_EMAIL_TEMPLATE,
  UPLOADING_MEDIA_REQUEST,
  UPLOADING_MEDIA_SUCCEEDED,
  UPLOADING_MEDIA_FAILED,
  UPDATE_PERSONAL_EMAIL_TEMPLATE_REQUEST,
  UPDATE_PERSONAL_EMAIL_TEMPLATE_SUCCEEDED,
  UPDATE_PERSONAL_EMAIL_TEMPLATE_FAILED
} from "../actions/actionTypes.jsx";

import _ from 'lodash';

const initialState = {
  loading: false,
  loadMore: true,
  invalidated: true,
  currentPage: -1,
  totalPages: 0,
  recordsPerPage: 0,
  items: [],
  error: null,
  template: {
    loading: false,
    creating: false,
    error: null,
    deleting: false,
    uploading: false,
    media: {
      image: [],
      error: null,
    },
  },
  defaultTemplate: {
    loading: false,
    item: null,
    error: null,
  },
  selectedTemplate: null,
};

function emailTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_EMAIL_TEMPLATES_REQUEST:
      return Object.assign({}, state, {
        ...state,
        loading: true,
        invalidated: true,
      });

    case FETCHING_EMAIL_TEMPLATES_SUCCEDDED: {
      const data = action.payload;
      const currentPage = data.pagination?.pageNumber || 0;
      const totalPages = data.pagination?.totalPagesCount || 0;
      const recordsPerPage = data.pagination?.itemsPerPage || 0;
      const totalRecordsCount = data.pagination?.totalRecordsCount || 0;
      const loadMore = currentPage + 1 < totalPages;
      const newRecords = data.records || [];

      let items = currentPage === 0 ? [...newRecords] : [...state.items, ...newRecords];

      items = items.reduce((acc, record) => {
        const index = acc.findIndex(r => r.id === record.id);
        if (index < 0) {
          return [...acc, record];
        } else {
          acc[index] = record;
          return acc;
        }
      }, []);

      items = items.reduce((acc, template) => {
        if (template.default) return [template, ...acc];
        return [...acc, template];
      }, []);

      return {
        ...state,
        loading: false,
        items,
        currentPage,
        totalPages,
        recordsPerPage,
        totalRecordsCount,
        loadMore,
        invalidated: false,
      };
    }

    case FETCHING_EMAIL_TEMPLATES_FAILED:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: false,
        error: action.payload.error,
      });

    case INVALIDATE_EMAIL_TEMPLATES:
      return Object.assign({}, state, {
        ...state,
        loading: false,
        invalidated: true,
        items: [],
        selectedTemplate: null
      });

    case SELECTION_EMAIL_TEMPLATE:
      return Object.assign({}, state, {
        ...state,
        selectedTemplate: action.payload,
      });

    case INVALIDATE_SELECTION_EMAIL_TEMPLATE:
      return Object.assign({}, state, {
        ...state,
        selectedTemplate: null,
      });

    case FETCHING_EMAIL_TEMPLATE_REQUEST:
      var id = action.payload;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          [id]: {
            fetching: true,
          },
        },
      });

    case FETCHING_EMAIL_TEMPLATE_SUCCEDDED: {
      const { id, value } = action.payload; 
      return {
        ...state,
        template: {
          ...state.template,
          [id]: {
            item: value.template,
            fetching: false,
          },
        },
      };
    }

    case FETCHING_EMAIL_TEMPLATE_FAILED:
      var id = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          [id]: {
            error: action.payload.error,
            fetching: false,
          },
        },
      });

    case CREATING_EMAIL_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          creating: true,
          error: null,
        },
      });

    case CREATING_EMAIL_TEMPLATE_SUCCEDDED: {
      const newTemplate = action.payload;
      const isDefault = newTemplate.default;
      const existingItems = _.get(state, "items", []);

      let updatedItems = existingItems.map(template => {
        if (isDefault && template.default) {
          return { ...template, default: false };
        }
        return template;
      });

      updatedItems = [newTemplate, ...updatedItems];

      updatedItems = updatedItems.reduce((acc, template) => {
        if (template.default) return [template, ...acc];
        return [...acc, template];
      }, []);

      return {
        ...state,
        template: { ...state.template, creating: false, error: null },
        items: updatedItems,
        selectedTemplate: newTemplate
      };
    }

    case CREATING_EMAIL_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          creating: false,
          error: action.payload,
        },
      });

    case UPDATING_EMAIL_TEMPLATE_REQUEST:
    case UPDATE_PERSONAL_EMAIL_TEMPLATE_REQUEST:
      var id = action.payload;
      var template = state.template[id] || {};
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          [id]: {
            ...template,
            updating: true,
          },
        },
      });

    case UPDATE_PERSONAL_EMAIL_TEMPLATE_SUCCEEDED:
    case UPDATING_EMAIL_TEMPLATE_SUCCEDDED: {
      const { id, response } = action.payload;
      const updatedTemplate = response.template || response;
      const isDefault = updatedTemplate.default;

      const items = state.items.map(item => {
        if (_.get(item, "id") === id) {
          return updatedTemplate;
        }
        if (_.get(item, "default") && isDefault) {
          return { ...item, default: false };
        }
        return item;
      });

      const sortedItems = items.reduce((acc, template) => {
        if (template.default) return [template, ...acc];
        return [...acc, template];
      }, []);

      return {
        ...state,
        items: sortedItems,
        template: {
          ...state.template,
          [id]: { item: updatedTemplate, updating: false },
          error: null,
        },
      };
    }
    case UPDATING_EMAIL_TEMPLATE_FAILED:
    case UPDATE_PERSONAL_EMAIL_TEMPLATE_FAILED:
      var id = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          error: action.payload.error,
          [id]: {
            updating: false,
          },
        },
      });
    case DELETING_EMAIL_TEMPLATE_REQUEST:
      var id = action.payload;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          deleting: true,
        },
      });
    case DELETING_EMAIL_TEMPLATE_SUCCEDDED:
      var id = action.payload.id;
      delete state.template[id];

      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          deleting: false,
        },
        items: state.items.filter((template, index) => {
          return template.id !== id;
        }),
      });
    case DELETING_EMAIL_TEMPLATE_FAILED:
      var id = action.payload.id;
      return Object.assign({}, state, {
        ...state,
        template: {
          ...state.template,
          deleting: false,
          [id]: {
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DEFAULT_EMAIL_TEMPLATE_REQUEST:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          loading: true,
        },
      });
    case FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          item: action.payload,
          loading: false,
          error: null,
        },
      });
    case FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          ...state.defaultTemplate,
          loading: false,
          error: action.payload,
        },
      });

    case INVALIDATE_DEFAULT_EMAIL_TEMPLATE:
      return Object.assign({}, state, {
        ...state,
        defaultTemplate: {
          loading: false,
          item: null,
        },
      });

    case UPLOADING_MEDIA_REQUEST:
      return {
        ...state,
        template: {
          ...state.template,
          uploading: true,
          media: {
            image: [],
          },
        },
      };

    case UPLOADING_MEDIA_SUCCEEDED:
      return {
        ...state,
        item: {
          ...action.payload,
        },
        template: {
          ...state.template,
          uploading: false,
          media: {
            image: [...state.template.media.image, action.payload.image],
          },
        },
      };

    case UPLOADING_MEDIA_FAILED:
      return {
        ...state,
        template: {
          ...state.template,
          uploading: false,
          media: {
            error: action.payload.error,
          },
        },
      };

    default:
      return state;
  }
}

export { emailTemplateReducer };
